<script>
import Layout from "../../layouts/print";
import appConfig from "@/app.config";


/* eslint-disable no-console */
export default {
  page: {
    title: "Co-Seller Contract",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      data:{},
    };
  },
  mounted() {
    this.data = {
      do_date_kh:"ថ្ងៃទី១៨ ខែមេសា ឆ្នាំ២០២៣",
      do_date_en: "April 18, 2023",
      code: "COOR-RHSS.CO-007",
      with_company_kh: "ក្រុមហ៊ុន អនឡាញ រៀល អុីស្ទេត",
      with_company_en: "ONLINE REAL ESTATE CO., LTD",
      with_seller_kh: "ហួ ប៊ុនធឿន",
      with_seller_en: "HOUR BUNTHOEUN",
      position_kh: "អ្នកលក់តាមផ្លូវ",
      position_en: "On road seller",
      address_kh: "អគារលេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ",
      address_en: "#742, St.1952, Bayap, Phnom Penh Thmei, Khan Sen Sok, Phnom Penh Capital",
      phone: "092 926 688 / 098 926 688",
      email: "info@h-residence.net",
      do_from_date_kh: "ថ្ងៃទី១ ខេមេសា ឆ្នាំ២០២៣",
      do_from_date_en: "1 april 2023",
      do_to_date_kh: "ថ្ងៃទី១ ខេមេសា ឆ្នាំ២០២៤",
      do_to_date_en: "1 april 2024",
      bank_account_name: "Tith Sochenda",
      bank_account_number: "43252354545",
      current_date_kh: "ថ្ងៃទី១ ខេមេសា ឆ្នាំ២០២៣",
      current_date_en: "1 april 2023",
    };
    
  },
  methods: {},
};

</script>

<template>
  <Layout>
    <center>
          <div class="col center c-color box-a4 frame-bor2">
            <p><br/></p>
            <p class="khm title l3">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="enb l3" style="font-size: 12.5pt;">KINGDOM OF CAMBODIA</p>
            <p class="khm sub-title l3" style="font-size: 12.5pt;">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="enb sub-title l3" style="font-size: 13pt;">NATION RELIGION KING</p>
            <p class="top-2">
              <img src="@/assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p class="khm sub-title">កិច្ចព្រមព្រៀង</p>
            <p class="khm sub-title">ស្តីពី កិច្ចសហប្រតិបត្តិការលក់លំនៅឋាន</p>
            <p class="khm sub-title">គម្រោង ៖ លំនៅឋាន អេច សែនសុខ</p>
            <p><br/></p>
            <p><br/></p>
            <p class="enb sub-title l3">AGREEMENT</p>
            <p class="enb sub-title l3">ON COOPERATION IN THE SALE OF HOUSING</p>
            <p class="enb sub-title l3">PROJECT: RESIDENCE H SENSOK</p>
            <p><br/></p>
            <p><br/></p>
            <p><span class="khm big-text">រវាង</span> <span class="enb big-text"> / BETWEEN</span></p>
            <p class="khm sub-title l3">ក្រុមហ៊ុនលំនៅឋាន អេចស៊ី ឯ.ក</p>
            <p class="enb h5 l3">LOMNOV THAN HC CO., LTD</p>

            <p><br/></p>
            <p><span class="khm big-text">ជាមួយនិង</span> <span class="enb big-text"> / AND</span></p>
            <p class="khm sub-title l3">{{ data.with_company_kh }}</p>
            <p class="enb h5 l3">{{ data.with_company_en }}</p>
            <p class="">
              <img src="@/assets/images/bellow.svg" style="width: 100px;"/>
            </p>

            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p class="l3"><br/></p>
            <p class="khm big-text">{{ data.do_date_kh }}</p>
            <p class="enb big-text">{{ data.do_date_en }}</p>
            <p><span class="khm big-text">លេខរៀង</span> <span class="enb big-text"> # : {{ data.code }}</span></p>
          </div>


          <div class="col dblack box-a4-long kh">
            <table width="100%">
              <tr>
                <td width="10%">
                  <p><br/></p>
                  <img src="@/assets/images/h-logo.svg" alt height="120" />
                </td>
                <td class="text-center">
                  <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
                  <p class="enb l3" style="font-size: 12.5pt;">KINGDOM OF CAMBODIA</p>
                  <p class="khm sub-title l3" style="font-size: 12.5pt;">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
                  <p class="enb sub-title l3" style="font-size: 13pt;">NATION RELIGION KING</p>
                  <p class="top-2">
                    <img src="@/assets/images/3symbol.svg" style="width: 150px;"/>
                  </p>
                  <p><br/></p>
                </td>
                <td width="10%">
                  <p><br/></p>
                  <div style="border:2px goldenrod solid; border-radius: 6px; width: 120px; height: 130px;"></div>
                </td>
              </tr>
            </table>
            
            <p class="khm sub-title">កិច្ចព្រមព្រៀង ស្តីពីកិច្ចសហប្រតិបត្តិការលក់លំនៅឋាន</p>
            <p class="khm sub-title">គម្រោង ៖ លំនៅឋាន អេច សែនសុខ</p>
            <p class="enb sub-title">AGREEMENT ON COOPERATION IN THE SALE OF HOUSING</p>
            <p class="enb sub-title">PROJECT : RESIDENCE H SENSOK</p>
            <p class="enb h5 sub-title" style="margin-top: -16px">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
            <table width="100%" class="doc-content top">
              <tr>
                <td width="20%"><p>&nbsp;</p></td>
                <td width="80%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td colspan="2">
                  <p><span class="khm">រវាង</span> <span class="enb"> / BETWEEN</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ក្រុមហ៊ុន</p>
                </td>
                <td>
                  <p class="khm">:	លំនៅឋាន អេចស៊ី ឯ.ក (តទៅហៅថាភាគី “ក”)</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">COMPANY NAME</p>
                </td>
                <td>
                  <p class="enb">:	LOMNOV THAN HC CO., LTD. (Hereinafter referred to as Party “A”)</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">តំណាងដោយ</p>
                </td>
                <td>
                  <p class="kh">:	លោក <span class="khm">  </span><span class="khb">តួនាទីៈ</span> ប្រធានគ្រប់គ្រងទូទៅ។</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">REPRESENTED BY</p>
                </td>
                <td>
                  <p class="en">:	Mr. <span class="enb"> </span>, <span class="enb">Title:</span> General Manager.</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">អាសយដ្ឋាន</p>
                </td>
                <td>
                  <p class="kh">:	អគារលេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ។</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">ADDRESS</p>
                </td>
                <td>
                  <p class="en">:	#742, St.1952, Bayap, Phnom Penh Thmei, Khan Sen Sok, Phnom Penh Capital.</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ទូរស័ព្ទ<span class="enb">/PHONE</span></p>
                </td>
                <td>
                  <p class="en">:	092 926 688 / 098 926 688, <span class="enb">Email:</span> info@h-residence.net</p>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <p><span class="khm">ជាមួយនិង </span> <span class="enb"> / AND</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ក្រុមហ៊ុន</p>
                </td>
                <td>
                  <p class="khm">:	{{ data.with_company_kh }} (តទៅហៅថាភាគី “ខ”)</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">COMPANY NAME</p>
                </td>
                <td>
                  <p class="enb">:	{{ data.with_company_en }}. (Hereinafter referred to as Party “B”)</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">តំណាងដោយ</p>
                </td>
                <td>
                  <p class="kh">:	លោក <span class="khm"> {{ data.with_seller_kh }} </span> <span class="khb">តួនាទីៈ</span> {{ data.position_kh }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">REPRESENTED BY</p>
                </td>
                <td>
                  <p class="en">:	Mr. <span class="enb"> {{ data.with_seller_en }}</span>, <span class="enb">Title:</span> {{ data.position_en }}.</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">អាសយដ្ឋាន</p>
                </td>
                <td>
                  <p class="kh">: {{ data.address_kh }}។</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="enb">ADDRESS</p>
                </td>
                <td>
                  <p class="en">:	{{ data.address_en }}.</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ទូរស័ព្ទ<span class="enb">/PHONE</span></p>
                </td>
                <td>
                  <p class="en">:	{{ data.phone }}, <span class="enb">Email:</span> {{ data.email }}</p>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="center">
                  <p><br/></p>
                  <P class="khm">ដោយហេតុថា<span class="enb"> / WHEREAS</span></P>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <P class="kh"><span class="m-4"></span> ភាគី “ក” បាននឹងកំពុងសាងសង់ និងលក់គម្រោង
                    <span class="khm"> លំនៅឋាន អេច សែនសុខ</span>
                    ដែលជាកម្មសិទិ្ធស្របច្បាប់របស់ភាគី “ក” តែមួយគត់។ ហើយភាគី “ខ” ជាភ្នាក់ងារលក់ ដែលបានទទួលសិទ្ធិពីភាគី “ក”។</P>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <P class="en">Party “A” has been building and selling projects 
                    <span class="enb">RESIDENCE H SENSOK</span>, 
                    which are the sole legal property of Party “A”. And Party “B” is a sales agent authorized by Party “A”.</P>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="center">
                  <p><br/></p>
                  <P class="khm">ភាគីទាំងពីរបានយល់ព្រមគោរព និងប្រតិបត្តិតាមគ្រប់លក្ខខណ្ឌដែលបានចែងក្នុងកិច្ចព្រមព្រៀងនេះ ប្រកបដោយភាពយុត្តិធម៌ ស្ម័គ្រចិត្ត សមភាព ផ្តល់ផលប្រយោជន៍ទៅវិញទៅមក ដោយភាពស្មោះត្រង់ និងជឿទុកចិត្ត ។</P>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="center">
                  <P class="enb">BOTH PARTIES AGREE TO ABIDE BY AND COMPLY WITH ALL THE CONDITIONS SET FORTH IN THIS CONTRACT THROUGH FAIR, VOLUNTARY, EQUITABLE, MUTUALLY BENEFICIAL, HONEST AND TRUSTWORTHY NEGOTIATIONS.</P>
                </td>
              </tr>
            </table>
            <table class="doc-content top text-justify">
              <tr>
                <td width="8%"></td>
                <td width="92%"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ១ : តម្លាភាព និងការធានានៃភាគីទាំងសងខាង</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 1 : TRANSPARENCY AND GUARANTEE OF BOTH PARTIES</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">1.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” និងភាគី “ខ” ត្រូវតែជាបុគ្គលពេញសិទ្ធិ និងស្របច្បាប់របស់ក្រុមហ៊ុន ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” and Party “B” must be the legally authorized persons of the companies.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">1.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” និងភាគី “ខ” ត្រូវតែជាបុគ្គលពេញសិទ្ធិ និងស្របច្បាប់របស់ក្រុមហ៊ុន ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” and Party “B” guarantee strict adherence to all conditions in this contract.
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ២ : វិសាលភាពការងារ និងរយៈពេលសហប្រតិបត្តិការ</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 2 : SCOPE OF WORK AND COOPERATION PERIOD</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">2.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    កិច្ចព្រមព្រៀងនេះ មានរយៈពេល១២ខែ គិតចាប់ពី{{ data.do_from_date_kh }} ដល់{{ data.do_to_date_kh }}។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    The term of this cooperation shall be 12 months from {{ data.do_from_date_en }} to  {{ data.do_to_date_en }}.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">2.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” នឹងផ្សព្វផ្សាយពាណិជ្ជកម្មអំពីគម្រោង
                    <span class="khm"> លំនៅឋាន អេច សែនសុខ</span> ឱ្យភាគី “ក” ដោយមិនផ្ដាច់មុខ ហើយអតិថិជនរបស់ ភាគី “ខ” ត្រូវធ្វើកិច្ចព្រមព្រៀងទិញ-លក់ ដោយផ្ទាល់ជាមួយភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” will promote the <span class="enb"> RESIDENCE H SENSOK</span> project for Party “A” on a non-exclusive basis and the sale by Party “B” to a customer shall be made through a direct contract with Party “A”.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">2.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” នឹងប្រើប្រាស់ធនធានផ្ទាល់ខ្លួនក្នុងការផ្សព្វផ្សាយពាណិជ្ជកម្ម ស្វែងរក និងណែនាំអតិថិជន ដើម្បីសម្រេចឱ្យបានគោលដៅលក់គម្រោង
                    <span class="khm"> លំនៅឋាន អេច សែនសុខ </span>ដែលចែងក្នុងកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” will use its own resources to promote, find and introduce customers in order to achieve the sales targets of the said the
                    <span class="enb"> RESIDENCE H SENSOK</span> project.
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              
 <!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៣ : សិទ្ធិ កាតព្វកិច្ច និងការទទួលខុសត្រូវរបស់ភាគី “ក”</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 3 : RIGHTS, DUTIES AND RESPONSIBILITIES OF PARTY “A”</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” គឺជាម្ចាស់នៃគម្រោង 
                    <span class="khm"> លំនៅឋាន អេច សែនសុខ</span> តែម្នាក់គត់ លក្ខខណ្ឌផ្សេងៗ កិច្ចព្រមព្រៀងលក់-ទិញ កាលវិភាគបង់ប្រាក់ នឹងត្រូវធ្វើឡើងជាមួយភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” is the sole owner of the project
                    <span class="enb"> RESIDENCE H SENSOK</span>. The conditions, sale-purchase contract, payment schedule and shall be made with Party “A”.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” គឺជាអ្នកគ្រប់គ្រងលើអតិថិជន និងការលក់របស់ភាគី “ខ” ទាំងស្រុង និងជាភាគីតែមួយគត់ដែលមានសិទ្ធិចុះហត្ថលេខាលើឯកសារលក់-ទិញ ដែលពាក់ព័ន្ធជាមួយភាគីអ្នកទិញផ្ទាល់ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” shall be directly in charge of the sale of all condo units of Party “B” and sign the relevant sale-purchase documents directly with a purchaser.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” ធានាថានឹងផ្តល់ព័ត៌មានផ្សេងៗដែលពាក់ព័ន្ធគម្រោងខុនដូខាងលើដល់ភាគី “ខ” ដូចជា៖ ទីតាំងគម្រោង ចំនួនយូនីត ប្រភេទយូនីត សេវាកម្មផ្សេងៗ លក្ខខណ្ឌនៃការលក់ តម្លៃលក់ ការបញ្ចុះតម្លៃ វិធីបង់ប្រាក់ និងលក្ខខណ្ឌផ្សេងៗទៀត ជាលាយលក្ខណ៍អក្សរក្រោយរយៈពេល១៥ថ្ងៃ ចាប់ពីថ្ងៃចុះហត្ថលេខាលើកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” guarantees to provide Party “B” with various information related to the said condo project such as project location, number of properties and types of units, services, terms of sale, sale price, discount, payment method and other conditions, which will be in writing after 15 days from the date of signing this contract.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.4</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” សុំរក្សាសិទ្ធិក្នុងការកែប្រែតម្លៃលក់ លក្ខខណ្ឌនៃការលក់ វិធីបង់ប្រាក់ និងលក្ខខណ្ឌផ្សេងៗទៀតរបស់គម្រោងដោយជូនដំណឹងទៅភាគី “ខ” មុនរយៈពេល០៧ថ្ងៃ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” reserves the right to change the sale price of the condo units, terms of sale, payment method and other conditions of the project by notifying Party “B” within 07 days.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.5</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    បើសិនអតិថិជនដែលណែនាំដោយភាគី “ខ” បានទិញយូនីតខុនដូ ពីគម្រោងខាងលើស្ថិតក្នុងរយៈពេលដែលបានចែងក្នុងកិច្ចព្រមព្រៀងនេះ ភាគី “ក” នឹងផ្ដល់ប្រាក់កម្រៃជើងសារឱ្យទៅភាគី “ខ” ដោយអនុលោមតាមវិធីសាស្រ្តទូទាត់ប្រាក់កម្រៃជើងសាររបស់ភាគី “ក” និងលក្ខខណ្ឌដែលកំណត់នៅក្នុងកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    If any customers introduced by Party “B” purchase the condo units of the above project within the period specified in this Contract, Party “A” will pay a commission to Party “B” in accordance with the commission payment method of Party “A” and the conditions set out in this Contract.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.6</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” នឹងចាត់ចែងបុគ្គលិកជួយសម្របសម្រួល និងណែនាំអតិថិជនរបស់ភាគី “ខ” ក្នុងករណីចាំបាច់ណាមួយដែលភាគី “ខ” ស្នើសុំជាជំនួយក្នុងការលក់របស់ខ្លួន ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” will assign staff to provide facilitation and introduce customers of Party “B” as may be requested by Party “B” in support of its sales.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.7</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងអំឡុងពេលនៃកិច្ចព្រមព្រៀង ភាគី “ក” មានសិទ្ធិក្នុងការតែងតាំងក្រុមការងារលក់ ឬភ្នាក់ងារលក់ និងចុះហត្ថលេខាលើកិច្ចព្រមព្រៀងដែលដូចគ្នា ឬស្រដៀងនឹងកិច្ចព្រមព្រៀងនេះជាមួយភាគីផ្សេងទៀតបាន ហើយភាគី “ក” នឹងមិនចាំបាច់បង់ប្រាក់កម្រៃជើងសារឱ្យទៅភាគី “ខ” លើចំនួនយូនីតខុនដូ ដែលបានលក់ដោយក្រុមការងារ ឬភ្នាក់ងារលក់ផ្សេងទៀតរបស់ភាគី “ក” ឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    During the agreement, Party "A" has the right to appoint a sales team or sales agent and sign an agreement that is the same or similar to this agreement with the other party, and Party "A" will not have to pay the commission to Party "B" on the number of condominium units sold by the Party "A" team or other sales agents of Party "A".
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">3.8</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” មានសិទ្ធិរំលាយកិច្ចព្រមព្រៀងនេះដោយឯកតោភាគីបាន បើសិនពិនិត្យឃើញថាភាគី “ខ” មិនបានគោរពតាមខ្លឹមសារទាំងឡាយក្នុងកិច្ចព្រមព្រៀងនេះ ហើយដែលមិនអាចជួយជម្រុញការលក់ដូរឱ្យបានប្រសើរឡើងក្នុងរយៈពេល០៣ខែ គិតចាប់ពីថ្ងៃបានចុះហត្ថលេខាលើកិច្ចព្រមព្រៀងនេះ ។ ការរំលាយកិច្ចព្រមព្រៀងនេះ ភាគី “ក” នឹងជូនដំណឹងជាលាយលក្ខណ៍អក្សរជាមុនដល់ភាគី “ខ” ក្នុងរយៈពេល១០ថ្ងៃ ។ ក្រោយពេលដែលទទួលបានការជូនដំណឹង ភាគី “ខ” ត្រូវផ្ដល់ជូននូវរាល់ឯកសាររក្សាទុករបស់អតិថិជន ដែលពាក់ព័ន្ធនឹងគម្រោងនេះទៅឱ្យភាគី “ក” ហើយប្រាក់កម្រៃជើងសារដែលនៅសល់នឹងទូទាត់ជូនភាគី “ខ” តាមលក្ខខណ្ឌទូទាត់ប្រាក់កម្រៃជើងសាររបស់ភាគី “ក” ៕
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” has the right to unilaterally terminate this contract if it is of the opinion that Party “B” has not complied with the contents in this contract and cannot promote the sale more effectively within 03 months from the date of signing this contract. Party “A” will notify Party “B” in writing within 10 days before the termination of this contract. Upon receipt of the notice, Party “B” shall provide the customer documents related to this project to Party “A” and the remaining portion of the commission will be paid to Party “B” in accordance with the terms of commission payment by Party “A”.
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>

<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៤ : សិទ្ធិ កាតព្វកិច្ច និងការទទួលខុសត្រូវរបស់ភាគី “ខ”</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 4 : RIGHTS, DUTIES AND RESPONSIBILITIES OF PARTY “B”</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” នឹងធ្វើការផ្សព្វផ្សាយជាសាធារណៈឱ្យបានទូលំទូលាយតាមរយៈប្រព័ន្ធផ្សព្វផ្សាយផ្សេងៗ ដូចជាកាសែត ការតាំងពិពរណ៍ ការផ្ញើរសារ ខិតប័ណ្ណផ្សព្វផ្សាយ បណ្តាញសង្គមផ្សេងៗ និងការប្រជុំផ្សព្វផ្សាយអំពីគម្រោងដែលមានស្របតាមគោលការណ៍លក់របស់ភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” shall do a wide range of publicity via various media such as newspapers, exhibitions, emails, leaflets, social media and promotional meetings about the project in accordance with the sales policy of Party “A”.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” នឹងទទួលរ៉ាប់រងក្នុងការបណ្តុះបណ្តាល និងផ្ដល់អនុសាសន៍ដល់បុគ្គលិករបស់ខ្លួន ឱ្យយល់ច្បាស់អំពីនិតិវិធីក្នុងការលក់ គោលការណ៍លក់ លក្ខខណ្ឌផ្សេងៗ និងគម្រោងដែលត្រូវលក់ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” will be responsible for training and recommending its staff to clearly understand the sales procedures, sales policies, conditions and projects to be sold.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” ជាអ្នកទទួលខុសត្រូវលើការចំណាយទាំងស្រុង លើការផ្សព្វផ្សាយពាណិជ្ជកម្ម ហើយត្រូវធានាថារាល់ការផ្សព្វផ្សាយរបស់ខ្លួន មិនត្រូវធ្វើឡើងក្រោមលក្ខខណ្ឌណាមួយដែលខុសពីលក្ខខណ្ឌរបស់ភាគី “ក” ឬធ្វើឱ្យប៉ះពាល់ ខូចខាតដល់ផលប្រយោជន៍ និងកេរ្តិ៍ឈ្មោះរបស់ភាគី “ក” ឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” is responsible for the full cost of advertising and shall ensure that all its advertisements are not made under any conditions that differ from the terms of Party “A” or make damage to the interests and reputation of Party “A”.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.4</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” មិនមានសិទ្ធិ ទទួលយកការបង់ប្រាក់ថ្លៃទិញខុនដូ ឬថ្លៃបង់លើសេវាផ្សេងៗពីអតិថិជនដោយផ្ទាល់បានឡើយ រាល់ការបង់ប្រាក់ អតិថិជនត្រូវបង់ជាមួយភាគី “ក” ដែលមានបង្កាន់ដៃទទួលប្រាក់ត្រឹមត្រូវ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” has no right to accept the payment from customers for condo unit price or other service charges; all payments by customers shall be made with Party “A” with proper receipt of the payment.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.5</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” មិនត្រូវផ្លាស់ប្ដូរ ឬកែប្រែតម្លៃលក់ ការបញ្ចុះតម្លៃ លេខសម្ភាល់យូនីត រូបភាពគម្រោង ប្លង់យូនីត ទំហំ ឬការគ្រប់គ្រងលើការបង់ថ្លៃទិញខុនដូ និងថ្លៃសេវាផ្សេងៗបានឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” shall not change or modify the sale price, discount, unit number, project image, unit plan, unit size or control over the payment of condo unit price and other charges.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.6</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” មិនមានសិទ្ធិចុះហត្ថលេខាលើកិច្ចព្រមព្រៀងលក់-ទិញ ឬការផ្លាស់ប្ដូរឈ្មោះអតិថិជនដែលបានទិញបន្ទប់ខុនដូរួចហើយបានឡើយ ។ បើពុំនោះទេភាគី “ខ” ត្រូវទទួលខុសត្រូវទាំងស្រុងចំពោះមុខច្បាប់ និងសំណងការខូចខាតទាំងឡាយខ្លួនបានប្រព្រឹត្ត ៕
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “B” has no right to sign a sale-purchase contract or change the name of the customer who has already bought a condo unit. Otherwise, Party “B” shall be fully responsible before the laws and compensation for any damages it has committed.
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
<tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៥ : អំពីអតិថិជន</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 5 : ABOUT CUSTOMERS</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    អតិថិជនដែលបានមកដល់ទីស្នាក់ការលក់របស់ភាគី “ក” គឺជាអតិថិជនរបស់ភាគី “ក” លើកលែងតែអតិថិជនដែលបានណែនាំដោយភាគី “ខ” ហើយបានផ្តល់ព័ត៌មានរបស់អតិថិជននោះមកភាគី “ក” យ៉ាងតិចឱ្យបាន០១ម៉ោងមុន តាមរយៈទូរស័ព្ទមកផ្នែកលក់ ឬបណ្តាញសង្គមផ្សេងៗ (ក្នុងកម្មវត្ថុ ព័ត៌មានស្ដីពីការស្នើសុំចុះបញ្ជីឈ្មោះអតិថិជន) ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Any customers who come to the sales office of Party “A” will be customers of Party “A”, except for those who are introduced by Party “B” and whose information is provided to Party “A” by the phone call at least 01 hour in advance or via company’s social media (the subject of which concerns the customer registration request).
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ចំពោះអតិថិជនដែលបានចុះឈ្មោះជាមុនជាមួយភាគី “ក” រួចហើយ ឬត្រូវជាបុគ្គលដែលពាក់ព័ន្ធនឹងក្រុមហ៊ុនរបស់ភាគី “ក” នោះភាគី “ក” មានសិទ្ធិក្នុងការអះអាងថា អតិថិជននោះមិនមែនជាអតិថិជនរបស់ភាគី “ខ” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    For a customer who has already pre-registered with Party “A” or for those who are related to the Company of Party “A”, Party “A” shall have the right to claim that they are not a customer of Party “B”.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” អនុញ្ញាតឱ្យភាគី “ខ” នាំអតិថិជនមកទស្សនកិច្ចផ្ទាល់នៅទីតាំងដាក់ក្រុមហ៊ុន បន្ទប់គំរូ ទីតាំងសាងសង់ របស់ភាគី “ក” និងអាចប្រើប្រាស់ប្លង់មាត្រដ្ឋានគម្រោង និងប្លង់យូនីតខុនដូ របស់ភាគី “ក” ដើម្បីបង្ហាញដល់អតិថិជនរបស់ខ្លួនបាន ។ ប៉ុន្តែភាគី “ខ” មិនអាចទទួលអតិថិជនដែលមកទស្សនកិច្ចនៅទីតាំងបន្ទប់គំរូ ឬនៅក្នុងការិយាល័យលក់របស់ភាគី “ក” បានឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” allows Party “B” to bring customers to visit the showroom of Party “A” and to use the project scale and condo unit layout of Party “A” to show to their customers. However, Party “B” cannot accept any customers who visit the showroom or pick up the phone of Party “A” in the showroom.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.4</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលដែលអតិថិជនរបស់ភាគី “ខ” បានចុះហត្ថលេខា ឬផ្តិតស្នាមមេដៃទិញខុនដូ នៃគម្រោងខាងលើជាមួយភាគី “ក” និងបាន បង់ប្រាក់លើកដំបូងស្មើនឹង១០% នៃតម្លៃយូនីត មានន័យថាភាគី “ខ” បានជោគជ័យក្នុងការលក់យូនីតខុនដូមួយ របស់ភាគី “ក” ហើយ ។ ភាគី “ក” នឹងបង់ប្រាក់កម្រៃជើងសារដល់ភាគី “ខ” ដូចដែលចែងក្នុងកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Once the customer of Party “B” signs and affix thumbprint to purchase condo units of the said project with Party “A” and make the first payment equivalent to 10% of the unit price, it means that Party “B” has successfully sold a condo unit of Party “A”. And Party “A” will pay a commission to Party “B” as stated in this contract.
                  </p>
                </td>
              </tr>

              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៦ : រយៈពេលកំណត់នៃអតិថិជនដែលបានណែនាំរួច</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 6 : TIME LIMIT ON CUSTOMERS INTRODUCED</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">6.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    រយៈពេលកំណត់សម្រាប់អតិថិជនដែលត្រូវបានណែនាំរួច គឺ១៥ថ្ងៃ គិតពីថ្ងៃដែលត្រូវបានទទួលស្គាល់ជាផ្លូវការដោយភាគី “ក” ក្រោយរយៈពេលនេះ អតិថិជននោះនៅតែមិនទាន់បានទិញយូនីតខុនដូ ឬភាគី “ខ” មិនបានធ្វើបច្ចុប្បន្នភាពទេនោះ មានន័យថាភាគី “ខ” បានបោះបង់អតិថិជននោះចោលហើយ ដូច្នេះអតិថិជននោះនឹងក្លាយជាអតិថិជនរបស់ភាគី “ក” ដោយស្វ័យប្រវត្តិ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    The time limit on customers introduced shall be 15 days from the date officially recognized by Party “A”. If after such period, the customer still has not purchased the condo unit or Party “B” has not made any updates, it shall mean that Party “B” has abandoned the customer and the customer will automatically become a customer of Party “A”.
                  </p>
                </td>
              </tr>

              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៧ : លក្ខណៈក្នុងការទូរទាត់ប្រាក់កំរៃជើងសារ</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 7 : NATURE OF PAYMENT OF COMMISSION FEES</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">7.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” នឹងផ្តល់ប្រាក់កម្រៃជើងសារឱ្យទៅភាគី “ខ” ជាមូលដ្ឋានក្រោយពីដកការបញ្ចុះតម្លៃរួចតាមលក្ខខណ្ឌដូចខាងក្រោម៖
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” will basically pay a commission to Party “B” after deducting the discount under the following conditions:
                  </p>
                  <table class="tbl_contract1">
                    <tr>
                      <th>
                        <p>រយៈពេលនៃប្រតិបត្តិការ</p>
                        <p class="en">DURATION OF TRANSACTION</p>
                      </th>
                      <th>
                        <p>ចំនួនការលក់ប្រចាំខែ</p>
                        <p class="en">NUMBER OF MONTHLY SALE</p>
                      </th>
                      <th>
                        <p>កម្រៃជើងសារ </p>
                        <p class="en">COMMISSION</p>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <p>{{ data.do_from_date_kh }} -> {{ data.do_to_date_kh }}</p>
                        <p class="en">{{ data.do_from_date_en }} -> {{ data.do_to_date_en }}</p>
                      </td>
                      <td>
                        <p class="kh text-center">០១ យូនីត  </p>
                        <p class="en text-center">01 Unit</p>
                      </td>
                      <td>
                        <p class="en text-center">5%</p>
                      </td>
                    </tr>
                    </table>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">7.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ការទូទាត់ប្រាក់កម្រៃជើងសារឱ្យទៅភាគី “ខ” អាស្រ័យលើលក្ខខណ្ឌបង់ប្រាក់របស់ភាគី “ក” ជាមួយអតិថិជន ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    The payment of commission to Party “B” is subject to the payment terms of Party “A” and the customer.
                  </p>
                  <table class="tbl_contract1 kh">
                    <tr>
                      <th colspan="2">
                        <p>បង់រំលស់ និងបង់ដំណាក់កាល</p>
                        <p class="en">INSTALLMENT AND STAGED PAYMENT</p>
                      </th>
                      <th colspan="2">
                        <p>បង់ផ្តាច់</p>
                        <p class="en">LUMP SUM PAYMENT</p>
                      </th>
                    </tr>
                    <tr>
                      <th width="25%"><p>ការបង់ប្រាក់ <span class="en small-text">(PAYMENT)</span></p></th>
                      <th width="25%"><p>កម្រៃជើងសារ <span class="en small-text">(COMMISSION)</span></p></th>
                      <th width="25%"><p>ការបង់ប្រាក់ <span class="en small-text">(PAYMENT)</span></p></th>
                      <th width="25%"><p>កម្រៃជើងសារ <span class="en small-text"> (COMMISSION)</span></p></th>
                    </tr>
                    <tr>
                      <td><p class="text-center">បង់បាន ១០%  (10% Paid)</p></td>
                      <td><p class="text-center">30%</p></td>
                      <td rowspan="3" colspan="2">
                        <p class="text-center kh">បង់ផ្តាច់ ១០០% ទូទាត់ចុងខែ
                        100% down payment at the end of the month
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td><p class="text-center">បង់បាន ២០%  (20% Paid)</p></td>
                      <td><p class="text-center">30%</p></td>
                    </tr>
                    <tr>
                      <td><p class="text-center">បង់បាន ៣០%  (30% Paid)</p></td>
                      <td><p class="text-center">40%</p></td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td class="right">
                  <p class="khli">7.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីអតិថិជនបញ្ឈប់កិច្ចព្រមព្រៀងទិញ-លក់លំនៅឋាន មុនការបង់ប្រាក់តិចជាង 10% នោះភាគី “ក” នឹងមិនទូទាត់ប្រាក់កម្រៃជើងសារជូនភាគី “ខ” ទេ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    In case the customer terminates the sale purchase agreement before the payment is less than 10%, Party "A" will not pay the commission to Party "B".
                  </p>
                  <table class="tbl_contract2 kh">
                    <tr>
                      <th colspan="3">
                        <p class="khb">ព័ត៌មានគណនីរបស់ភាគី “ខ” <span class="enb">(ACCOUNT DETAILS OF PARTY “B”)</span></p>
                      </th>
                    </tr>
                    <tr>
                      <td width="40%"><p >ឈ្មោះម្ចាស់គណនី (Account Holder’s Name)</p></td>
                      <td width="2%">:</td>
                      <td width="58%"><p class="enb">{{ data.bank_account_name }}</p></td>
                    </tr>
                    <tr>
                      <td><p>លេខគណនីធនាគារ (Bank Account Number)</p></td>
                      <td width="2%">:</td>
                      <td><p class="enb">{{ data.bank_account_number }}</p></td>
                    </tr>
                    <tr>
                      <td><p>ឈ្មោះធនាគារ (Bank Name)</p></td>
                      <td width="2%">:</td>
                      <td><p class="enb">ADVANCED BANK OF ASIA LIMITED</p></td>
                    </tr>
                    <tr>
                      <td><p>អាសយដ្ឋានធនាគារ (Bank Address)</p></td>
                      <td width="2%">:</td>
                      <td><p class="enb">148 Preah Sihanouk blvd, Sangkat Boeng Keng Kang I, Khan Boeng Keng Kang, Phnom Penh.</p></td>
                    </tr>
                    <tr>
                      <td><p>កូដ SWIFT (SWIFT Code)</p></td>
                      <td width="2%">:</td>
                      <td><p class="enb">ABAAKHPP</p></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">7.4</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីដែលការទូរទាត់ប្រាក់កម្រៃជើងសារ មិនបានជោគជ័យដោយសារ ព័ត៌មានគណនីរបស់ភាគី “ខ” មិនត្រឹមត្រូវ ឬកង្វះលក្ខខណ្ឌណាមួយក្នុងការដកប្រាក់ ភាគី “ខ” នឹងត្រូវទទួលខុសត្រូវចំពោះបន្ទុកនៃការទូរទាត់លើកទី០២ ឬប្ដូរគណនីផ្សេងទៀតដើម្បីទូរទាត់ប្រាក់កម្រៃជើងសារបាន ។ ការផ្លាស់ប្ដូរគណនីត្រូវមានការធ្វើកិច្ចព្រមព្រៀងបន្ថែមដោយទេ្វភាគី ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    In the event that the commission payment is unsuccessful due to incorrect account details of Party “B” or lack of any withdrawal conditions, Party “B” will be responsible for the charge for the second payment or change another account for payment of the commission fee. The change of account requires an additional agreement by both Parties.
                  </p>
                </td>
              </tr>


              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៨ : ការទទួលខុសត្រូវក្នុងការបំពានកិច្ចព្រមព្រៀង</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 8 : LIABILITY FOR BREACH OF CONTRACT</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">8.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” នឹងផ្ដល់ដំណឹងជាបន្ទាន់ទៅភាគី “ខ” ជាលាយលក្ខណ៍អក្សរដើម្បីធ្វើការកែតម្រូវ និងមានសិទ្ធិក្នុងការលុបចោលកិច្ចព្រមព្រៀងនេះដោយឯកតោភាគី ហើយធ្វើការស៊ើបអង្កេតលើការទទួលខុសត្រូវក្នុងផ្លូវច្បាប់របស់ភាគី “ខ” ហើយរាល់ការខូចខាតរបស់ភាគី “ក” ឬរបស់អតិថិជន ជាបន្ទុករបស់ភាគី “ខ” ប្រសិនបើភាគី “ខ” ស្ថិតនៅក្រោមលក្ខខណ្ឌដូចចែងខាងក្រោម៖
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    Party “A” shall immediately notify Party “B” in writing for corrective action and have the right to unilaterally terminate this Contract and to investigate the legal liability of Party “B”. And all damages incurred by Party “A” or customers shall be borne by Party “B” if Party “B” falls under any of the following conditions:
                  </p>
                  <table width="100%">
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">ធ្វើការប្រមូលប្រាក់ពីអតិថិជនដោយផ្ទាល់ (រួមបញ្ចូលទាំងប្រាក់កក់ និង តម្លៃទិញខុនដូ) ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Collect money from customers (including deposit and condo purchase price).</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">ការចុះកិច្ចព្រមព្រៀងណាមួយជាមួយអតិថិជន ដោយពុំមានការអនុញ្ញាត្តពី ភាគី “ក” ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Sign any contract with the customer without the permission of Party “A”.</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">បង្ហាញ ឬប្រកាសព័ត៌មានការសម្ងាត់របស់ភាគី “ក” ដោយមិនមានការអនុញ្ញាត្ត ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Disclose or divulge confidential information of Party “A” without authorization.</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">ផ្ទេរ ឬចុះកិច្ចព្រមព្រៀងបន្ត លើការទទួលខុសត្រូវរបស់ខ្លួន ក្រោមកិច្ចព្រមព្រៀងនេះ ដោយមិនមានការអនុញ្ញាត្ត ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Transfer or subcontract its responsibilities under this contract without authorization.</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">ប្រព្រឹត្តអំពើណាមួយ ដែលធ្វើឱ្យមានផលប៉ះពាល់ដល់សិទ្ធិ និងកិត្តិយសរបស់ភាគី “ក” ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Commit any act causing prejudice to the rights and honor of Party “A”.</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb">- </td>
                      <td width="93%"><p class="kh">ទទួលប្រាក់កម្រៃជើងសារមិនសមរម្យ ដោយឃុបឃិតគ្នាជាមួយបុគ្គលិករបស់ភាគី “ក” ។</p></td>
                    </tr>
                    <tr>
                      <td width="7%" style="text-align: right;" class="enb"> </td>
                      <td width="93%"><p class="en">Receive inappropriate commissions in collusion with the staff of Party “A”.</p></td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
<!-- <tr><td><p><span></span></p></td></tr> -->
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ ៩ : សុពលភាព និងការបញ្ចប់នៃកិច្ចព្រមព្រៀង</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="enb">Article 9 : EFFECT AND TERMINATION OF CONTRACT</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    កិច្ចព្រមព្រៀងនេះមានសុពលភាពចាប់ពីថ្ងៃដែលភាគីទាំងពីរបានចុះហត្ថលេខា និងផ្តិតស្នាមមេដៃលើកិច្ចព្រមព្រៀងនេះតទៅ ។ ប្រសិនបើកិច្ចព្រមព្រៀងត្រូវបានផុតកំណត់ដោយមិនមានការបន្ត ឬកិច្ចព្រមព្រៀងមិនទាន់ផុតកំណត់ តែត្រូវបានប្រតិបត្តិរួចរាល់ នោះកិច្ចព្រមព្រៀងនេះនឹងត្រូវបញ្ចប់ដោយស្វ័យប្រវត្តិ បន្ទាប់ពីមានការទូរទាត់ប្រាក់រួចរាល់ពីភាគីទាំងពីរ ៕
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    This Contract shall become effective from the date on which it is signed and thumb-printed by both Parties. If the Contract expires without renewal or the Contract has not yet expired but has already been executed, this Contract shall automatically terminate after the payment has been completed by both Parties.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.2</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងអំឡុងពេលនៃកិច្ចព្រមព្រៀងនេះ ភាគីទាំងពីរត្រូវគោរពតាមលក្ខខណ្ឌ ដែលបានព្រមព្រៀងគ្នាឱ្យបានជាក់លាក់ បើពុំនោះទេភាគីដែលបំពានត្រូវទទួលរ៉ាប់រងការខូចខាតទៅភាគីម្ខាងទៀត ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    During the term of this Contract, both Parties shall abide by the terms expressly agreed upon; otherwise, the breaching Party shall be liable to the other Party for any damages incurred.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.3</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងអំឡុងពេលនៃកិច្ចព្រមព្រៀងនេះ ប្រសិនបើមានហេតុការណ៍ធ្ងន់ធ្ងរណាមួយកើតឡើង ដែលធ្វើឱ្យមានផលប៉ះពាល់ដល់លក្ខខណ្ឌណាមួយនៃកិច្ចព្រមព្រៀង ភាគីដែលរងការប៉ះពាល់ត្រូវផ្ដល់ដំណឹងជាបន្ទាន់ដល់ភាគីម្ខាងទៀតជាលាយលក្ខណ៍អក្សរ ជាមួយភស្តុតាង ក្នុងពេលវេលាសមរម្យ ដើម្បីសម្រាលការខូចខាត ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    In the event of any serious incident occurring during the term of this Contract, affecting any condition of the Contract, the affected party shall immediately notify the other Party in writing with evidence in a timely and appropriate manner to mitigate damages.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.4</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ខ្លឹមសារនៃកិច្ចព្រមព្រៀងនេះត្រូវមានការត្រួតពិនិត្យជាក់លាក់ ហើយមិនមានភាគីណាមួយមានសិទ្ធិក្នុងការផ្លាស់ប្ដូរកិច្ចព្រមព្រៀង នេះដោយគ្មានការអនុញ្ញត្តឡើយ ។ ការផ្លាស់ប្តូរណាមួយត្រូវមានការព្រមព្រៀងគ្នា និងចុះហត្ថលេខាពីភាគីទាំងសងខាង ដែលស្ថិតក្រោមឥទ្ធិពលច្បាប់ដូចគ្នា ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    The contents of this Contract shall be subject to certain scrutiny and no party shall have the right to modify this Contract without authorization. Any such modification shall be agreed upon and signed by both Parties under the same legal force.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.5</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    កិច្ចព្រមព្រៀងនេះត្រូវធ្វើឡើងក្រោមច្បាប់នៃប្រទេសកម្ពុជា ភាគីទាំងពីរបានព្រមព្រៀងគ្នាថា ក្នុងករណីមានជម្លោះដែលមិនអាចដោះស្រាយតាមការចរចាទ្វេភាគីបាន នឹងត្រូវបញ្ជូនទៅគណៈកម្មការអាជ្ញាកណ្ដាលនៃព្រះរាជាណាចក្រកម្ពុជា ជាអ្នកដោះស្រាយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    This Contract shall be governed by the Cambodian laws. It is agreed that in the event of a dispute that could not be resolved through bilateral negotiations, it shall be referred to the Arbitration Committee of the Kingdom of Cambodia for resolution.
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">9.6</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    កិច្ចព្រមព្រៀងនេះធ្វើឡើងជាពីរច្បាប់ និងពីរភាសារ (ខ្មែរ និងអង់គ្លេស) យកភាសារខ្មែរជាគោល ភាគីទាំងពីររក្សាទុកម្នាក់មួយច្បាប់ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="en" style="text-align: justify;">
                    This contract is made in duplicate copies and 02 languages (Khmer and English). The Khmer version of the contract shall prevail and parties each keeping 01 copy.
                  </p>
                </td>
              </tr>
            </table>
            <p><br/></p>
            <table width="100%">
              <tr>
                <td></td>
                <td>
                  <p style="text-align: center; font-size: 11pt" class="kh">ធ្វើភ្នំពេញ, {{ data.current_date_kh }}<br/>
                  <span style="text-align: center" class="en">Done in Phnom Penh, {{ data.current_date_en }}</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center; font-size: 12pt" class="khm">ហត្ថលេខា ភាគី “ខ”<br/>
                  <span style="text-align: center" class="enb">SIGNATURE OF PARTY “B”</span></p>
                </td>
                <td>
                  <p style="text-align: center; font-size: 12pt" class="khm">ហត្ថលេខា ភាគី “ក”<br/>
                  <span style="text-align: center" class="enb">SIGNATURE OF PARTY “A”</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{ data.with_seller_kh }}<br/>
                  <span style="text-align: center" class="enb">{{ data.with_seller_en }}</span></p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm"><br/>
                  <span style="text-align: center" class="enb"></span></p>

                </td>
              </tr>
            </table>
            
          </div>
    </center>
  </Layout>
</template>